<div class="dialog-banner">
  <div class="banner-left">
    <div class="banner-title">Saisie de paiement</div>
    <div class="banner-meta">
      <span class="patient-line"><strong>Patient :</strong> {{ data.patientName }}
        <mat-icon *ngIf="!paiementPatientSeul" class="edit-stealth" (click)="changePatient()" matTooltip="Modifier le patient associée à la facture">edit</mat-icon>
      </span>
      <span><strong>Facture :</strong> {{ data.numFacture || '—' }}</span>
      <span><strong>Date :</strong> {{ data.dateFacture | date:'dd/MM/yyyy' }}</span>
    </div>
  </div>

  <div class="banner-right">
    <div class="banner-content">
      <div class="banner-caption">Montant dû {{ paiementPatientSeul ? 'patient' : '' }}</div>
      <div class="banner-rest">{{ meta.restant  | number:'1.2-2' }} €</div>
      <div class="banner-amount" >Total facture : {{ meta.total  | number:'1.2-2' }} €</div>
    </div>
    <div class="banner-actions">
      <button mat-icon-button (click)="close()" class="banner-close" aria-label="Fermer">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>

<mat-dialog-content>

  <!-- Bloc payeur -->
  <div class="payeur-block" [formGroup]="form" *ngIf="meta.restant > 0">
    <mat-checkbox color="primary" class="checkbox" formControlName="regleParTiers">
      Réglé par un tiers (autre que assuré ou parent(s))
    </mat-checkbox>

    <!-- Si NON réglé par le patient : afficher le champ + chips -->
    <div *ngIf="form.get('regleParTiers')?.value" class="payeur-non-patient">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Payeur</mat-label>
        <input matInput formControlName="payeurNom" placeholder="Ex. AMO, AMC, EHPAD…" />
        <mat-error *ngIf="form.get('payeurNom')?.hasError('required')">
          Payeur obligatoire
        </mat-error>
        <mat-hint class="hint">Indiquez le tiers payeur :
           <mat-chip-list aria-label="Raccourcis payeur" class="hint-chips">
            <mat-chip class="chip"
              *ngFor="let s of payeurSuggestions"
              (click)="applyPayeur(s)"
              [selected]="(form.get('payeurNom')?.value || '').toUpperCase() === s.toUpperCase()"
              selectable="false"
              removable="false">
              {{ s }}
            </mat-chip>
          </mat-chip-list>
        </mat-hint>
      </mat-form-field>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="onAddPaiement()" *ngIf="meta.restant > 0">

    <!-- Segmented control au lieu du select -->
    <div class="mode-segment">
      <!-- <label class="seg-label">Mode de paiement</label> -->
      <mat-button-toggle-group
        [formControl]="form.get('mode')"
        class="toggle-grid" appearance="outline" [multiple]="false" name="mode">
        <mat-button-toggle *ngFor="let m of modes" [value]="m.value" class="toggle-tile"
          [class.is-checked]="form.get('mode')?.value === m.value" [disabled]="paiementPatientSeul && (m.value === 'AMO' || m.value === 'AMC')">
          <mat-icon class="tile-icn mr-1">{{ m.icon }}</mat-icon>
          <span class="tile-label">{{ m.label }}</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="add-paiement">
      <div class="add-montant">
        <mat-form-field appearance="outline" class="input-montant">
          <mat-label>Montant</mat-label>
          <input matInput type="number" formControlName="montant"
            min="0.00" step="1" inputmode="decimal" placeholder="0.00"/>
          <mat-icon matSuffix>euro</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="input-date">
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="datePaiement" />
          <mat-hint> </mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
          Ajouter
        </button>
      </div>
      <div class="quick-amounts">
        <mat-chip class="chip"
          *ngFor="let mr of montantRapide"
          (click)="applyMontantRapide(mr)"
          selectable="false"
          removable="false">
          {{ mr.label }} {{ mr.value | number:'1.2-2' }} €
        </mat-chip>
      </div>
      <div class="add-montant cheque" *ngIf="form.get('mode')?.value === 'CHEQUE'">
        <mat-form-field appearance="outline" class="input-cheque-numero">
          <mat-label>Numéro de chèque</mat-label>
          <input matInput formControlName="numeroCheque">
        </mat-form-field>

        <mat-form-field appearance="outline" class="input-cheque-banque">
          <mat-label>Banque</mat-label>
          <input matInput formControlName="banqueCheque">
        </mat-form-field>
      </div>
      <div class="add-note" >
        <mat-form-field appearance="outline" class="input-notes">
          <mat-label>Notes (optionnel)</mat-label>
          <textarea matInput rows="3" formControlName="note" placeholder="Ajouter une note (ex: numéro de chèque)..."></textarea>
        </mat-form-field>
      </div>
    </div>

  </form>

  <table mat-table [dataSource]="listPaiements" *ngIf="listPaiements.length > 0">
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let lp">{{ lp.datePaiement }}</td>
    </ng-container>

    <ng-container matColumnDef="mode">
      <th mat-header-cell *matHeaderCellDef>Mode</th>
      <td mat-cell *matCellDef="let lp">{{ lp.type }}</td>
    </ng-container>

    <ng-container matColumnDef="montant">
      <th mat-header-cell *matHeaderCellDef>Montant</th>
      <td mat-cell *matCellDef="let lp">{{ lp.montantRegle | number:'1.2-2' }} €</td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef>Note</th>
      <td mat-cell *matCellDef="let lp"
        [matTooltip]="lp.commentaire || ''"
        [matTooltipDisabled]="!lp.commentaire">
      <span class="ellipsis-1">{{ lp.commentaire || '—' }}</span>
    </td>
    </ng-container>
    <ng-container matColumnDef="par">
      <th mat-header-cell *matHeaderCellDef>par</th>
      <td mat-cell *matCellDef="let lp">{{ lp.payeurNom || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let lp; let i = index">
        <button mat-icon-button color="warn" (click)="onDeletePaiement(lp)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['date','par', 'mode','montant','note','actions']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['date','par','mode','montant','note','actions'];"></tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Fermer</button>
</mat-dialog-actions>
